import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import Button from '../../components/Button'
import Modal from '../../components/Modal'
import Row from '../../components/Row'
import patient from '../../stores/patient'
import MedicationForm from './MedicationForm'

@observer
export default class MedicationModal extends Component {
  @observable
  fields = {
    prescription: '',
    eye: '',
    frequency: '',
    prescriptionStartDate: '',
    prescriptionEndDate: '',
  }

  @action
  setField = event => {
    let value

    if (event.target.name === 'frequency') {
      value = event.target.value.replace(/\D/g, '').slice(0, 3)
    } else {
      value = event.target.value
    }

    this.fields[event.target.name] = value
  }

  submit = () => {
    const { onClose } = this.props
    console.log('MedicationModal submit')

    if (this.fields.prescription && this.fields.eye) {
      patient.addMedication(this.fields)
      onClose()
    }
  }

  checkSubmit = event => {
    if (event.keyCode === 13) {
      this.submit()
    }
  }

  render() {
    const { onClose } = this.props

    return (
      <Modal title="titles.addNewMedication" onClose={onClose}>
        <Modal.Pad>
          <form onKeyDown={this.checkSubmit}>
            <MedicationForm
              hideMonitor={true}
              allowEmptyValues={true}
              prescription={this.fields.prescription}
              eye={this.fields.eye}
              frequency={this.fields.frequency}
              prescriptionStartDate={this.fields.prescriptionStartDate}
              prescriptionEndDate={this.fields.prescriptionEndDate}
              monitors={this.fields.monitors || []}
              onChange={this.setField}
              onSubmit={this.submit}
            />
          </form>
        </Modal.Pad>
        <Modal.Divider />
        <Modal.Pad>
          <Row>
            <Row.Cell>
              <Button
                color="gray"
                str="titles.cancel"
                onClick={onClose}
              />
            </Row.Cell>
            {this.fields.prescription && this.fields.eye &&
              <Row.Cell>
                <Button
                  color="blue"
                  str="titles.create"
                  type="submit"
                  onClick={this.submit}
                />
              </Row.Cell>
            }
          </Row>
        </Modal.Pad>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/EditPatient/MedicationModal.js